<script setup>
import BaseModal from "@/components/global-themed/BaseModal.vue";
import KitIcon from "@/components/approval-center/partials/kit/KitIcon.vue";
import DefaultButton from "@/components/global-themed/buttons/DefaultButton.vue";
import ModalContentWrapper from "@/components/global-themed/ui/modals/ModalContentWrapper.vue";
import ModalHeading from "@/components/global-themed/ui/modals/ModalHeading.vue";
import ModalSubText from "@/components/global-themed/ui/modals/ModalSubText.vue";
import ModalHeader from "@/components/global-themed/ui/modals/ModalHeader.vue";
import KitModalHeader from "@/components/global-themed/ui/modals/KitModalHeader.vue";
import ModalTextAreaWrapper from "@/components/global-themed/ui/modals/ModalTextAreaWrapper.vue";
import {ref, watch} from "vue";

const inputValue = defineModel({
  type: String,
  required: true,
});

const emit = defineEmits(['close', 'confirm']);

const input = ref('');
watch(() => inputValue.value, (newValue) => (input.value = newValue), { immediate: true });

const handleContinue = () => {
  emit('update:modelValue', input.value);
  emit('confirm');
}
</script>

<template>
  <Teleport
    to=".tailwind"
  >
    <BaseModal
      modal-class="tw-w-[800px]"
      @close="emit('close')"
    >
      <ModalContentWrapper>
        <KitModalHeader>
          <KitIcon
            class="tw-w-[88px]"
            state="error"
          />

          <ModalHeader>
            <ModalHeading>No Problem!</ModalHeading>

            <ModalSubText>
              Looks like the content didn’t quite hit the mark — or we weren’t able to generate a response at all. You can make any edits or add your own response directly in the box below. Once you’re done, click <span class="tw-font-bold">Publish</span> and I’ll post it for you!
            </ModalSubText>
          </ModalHeader>
        </KitModalHeader>

        <div class="tw-flex tw-flex-col tw-gap-6">
          <slot />
        </div>

        <div class="tw-flex tw-flex-col tw-gap-6">
          <span class="tw-flex tw-gap-3 tw-text-neutral-900 tw-font-bold tw-text-2xl tw-leading-none">
            <slot name="label" />
          </span>

          <ModalTextAreaWrapper>
            <div>
              <textarea
                v-model="input"
                autofocus
                rows="8"
                class="tw-w-full tw-text-neutral-900 tw-text-base tw-resize-none"
              />
            </div>
          </ModalTextAreaWrapper>
        </div>

        <div class="tw-flex tw-items-center tw-gap-4 tw-self-end">
          <DefaultButton
            variant="primary-inverted"
            @click="emit('close')"
          >
            Cancel
          </DefaultButton>
          <DefaultButton
            :disabled="!input"
            @click="handleContinue"
          >
            Publish
          </DefaultButton>
        </div>
      </ModalContentWrapper>
    </BaseModal>
  </Teleport>
</template>
